import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import Colors from '../../../../constants/Colors';
import Style from '../../../../constants/Style';
import Button from '../../../Button';
import AlertIconMobile from '../../../16pxIcons/AlertIconMobile';

interface InvalidCodeModalProps {
  message: string | null,
  hide: () => void,
  back: () => void,
}

const InvalidCodeModal = ({
  message, hide, back,
}: InvalidCodeModalProps) => (message ? <View style={[StyleSheet.absoluteFill, styles.container]}>
      <View style={styles.icon}>
        <AlertIconMobile />
      </View>
      <Text style={styles.title}>{`This QR code is ${message}.`}</Text>
      <Text style={styles.subtitle}>{'Please scan a different code.'}</Text>
      <View style={Style.row}>
        <Button
          title='Cancel'
          onPress={hide}
          style={styles.button}
        />
        <Button
          title='Scan again'
          onPress={back}
          affirmative
          style={styles.button}
        />
      </View>
    </View> : null);

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
    alignItems: 'center',
    paddingTop: 40,
    backgroundColor: '#fff',
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: Colors.light.hereworksBlue500,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    lineHeight: 24,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlue500,
    marginTop: 24,
    marginHorizontal: 24,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_700Bold',
    color: Colors.light.hereworksBlack400,
    marginBottom: 27,
  },
  button: {
    flex: undefined,
  },
});

export default InvalidCodeModal;
